import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {isMobile} from '../../../../../commons/selectors/environment'
import {useSettings} from '../../../hooks/use-settings'
import settingsParams from '../../../settingsParams'
import {useWidgetState} from '../../hooks/state-provider'
import {useVisibilityStyles} from '../../hooks/use-visibility-styles'
import s from './main-list-title.scss'
import {classes} from './main-list-title.st.css'

export const MainListTitle = () => {
  const {get} = useSettings()
  const {
    allBreakpoints: {isListMainTitleEnabled},
  } = useVisibilityStyles()

  const mobile = useWidgetState(isMobile)
  const title = get(settingsParams.listGeneralTitle)
  const listTitleTag = get(settingsParams.listTitleTag)

  return isListMainTitleEnabled() ? (
    <Text
      className={classNames(classes.title, mobile ? s.mobileLayout : s.desktopLayout)}
      data-hook={DH.listTitle}
      tagName={listTitleTag}
    >
      {title}
    </Text>
  ) : null
}
